import { Check, X } from 'lucide-react';
import { useFormContext } from 'react-hook-form';

import { Button } from '@/_components';

import { isStatusTrue, statusOptions, statusToStr } from '../../../_schemas/status-input/schema';

export function StatusButtonInput({
  isPending,
  onUpdate,
}: {
  isPending: boolean;
  onUpdate: (value: Record<string, 'inactive' | 'active'>, msg: string) => void;
}) {
  const form = useFormContext();
  const [status] = form.watch(['status']);

  const handleStatusCtrl = () => {
    const newOption = isStatusTrue(status) ? statusOptions[2] : statusOptions[1];
    form.setValue('status', newOption);
    onUpdate({ status: statusToStr(newOption) }, 'Status has been updated successfully');
  };

  return (
    <Button
      as="link"
      className="justify-start"
      disabled={isPending}
      size="xs"
      onClick={handleStatusCtrl}
      icon={isStatusTrue(status) ? Check : X}
      iconClassName={isStatusTrue(status) ? 'text-success' : 'text-error'}
      aria-label="Toggle Status"
    >
      {status.name}
    </Button>
  );
}
